/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AppNamespaceEnum {
    AI_CHAT = 'ai_chat',
    AI_MINI_TOOL = 'ai_mini_tool',
    AI_IMAGE = 'ai_image',
    AI_SPEECH_RECOGNITION = 'ai_speech_recognition',
    AI_PERSONA = 'ai_persona',
    AI_DOCUMENT_QA = 'ai_document_qa',
    AI_ASSISTANT = 'ai_assistant',
    AI_FEEDBACK = 'ai_feedback',
    AI_IMAGE_RECOGNITION = 'ai_image_recognition',
    AI_CONVERTER = 'ai_converter',
    WORKSHEET_WIZARD = 'worksheet_wizard',
    PUPIL_FEEDBACK = 'pupil_feedback',
    WORKSHEET = 'worksheet',
    CLASSROOM_SCREEN = 'classroom_screen',
    PINBOARD = 'pinboard',
    SURVEYS = 'surveys',
    TEXT_EDITOR = 'text_editor',
    WEBSITE = 'website',
    VIDEO_RECORDER = 'video_recorder',
    AUDIO_RECORDER = 'audio_recorder',
    SCREEN_RECORDER = 'screen_recorder',
    WORD_CLOUDS = 'word_clouds',
    LINK_SHORTENER = 'link_shortener',
    FILE_SHARING = 'file_sharing',
    QRCODES = 'qrcodes',
    SCHOOL_CLASS = 'school_class',
}
